import { HttpClient, HttpParams } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { of as throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import moment from 'moment-timezone';
import { AuthenticationService } from '../auth/authentication.service';
import { environment } from 'src/environments/environment';
import { UtilServiceService } from './utilService/util-service.service';

@Injectable({
  providedIn: 'root'
})
export class QrExportService {

 public refreshAssetList$: EventEmitter<any>;
  constructor(
    private http: HttpClient,
    private auth: AuthenticationService,
    private util: UtilServiceService,
  ) {
    this.refreshAssetList$ = new EventEmitter();

   }
   /**================================== List Of Asset =========================*/
    public getAssetListByFilter(
      search: any,
      assetTypeId: any,
      statusId: any,
      fromDate: any,
      toDate: any,
      parameters: any,
    ) {
      let params = new HttpParams();
      if (search) params = params.set("search", search);
      if (assetTypeId) params = params.set("assetTypeIds", assetTypeId);
      if (statusId) params = params.set("statusId", statusId);
      if (fromDate && toDate) {
        fromDate = this.util.timeFormatter(moment("00:00:00", "h:mm A").format("h:mm A"), moment(fromDate, "YYYY-MM-DD").format("YYYY-MM-DD")).toISOString();
        toDate = this.util.timeFormatter(moment("23:59:00", "h:mm A").format("h:mm A"), moment(toDate, "YYYY-MM-DD").format("YYYY-MM-DD")).toISOString();
        params = params
          .set("createdFrom", fromDate)
          .set("createdTo", toDate);
      }
  
      if (parameters)
        params = params
          .set("startFrom", parameters.startRow)
          .set("perPage", "25")
          .set("columnName", parameters.sortModel[0].colId)
          .set("sortOrder", parameters.sortModel[0].sort);
  
      return this.http .get(environment.base_url + "/assets/qr", { observe: "response",  params: params }) .pipe( map((resp: any) => {
            return resp;
          }),
          catchError((error) => {
            return throwError(error);
          })
        );
    }
    /*

    * Create Product
    * @param body
    * @returns Observable<any>
    */
  public getAssetSerialNumbers(body: any) {
    return this.http .post(environment.base_url + '/assets/qr/serial-numbers', body, { observe: "response" })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }

  /**================================== List Of Product =========================*/
    public getProductListByFilter(
      search: any,
      productTypeId: any,
      productFamilyId: any,
      fromDate: any,
      toDate: any,
      parameters: any,
    ) {
      let params = new HttpParams();
      if (search) params = params.set("search", search);
      if (productTypeId) params = params.set("productTypeIds", productTypeId);
      if (productFamilyId) params = params.set("productFamilyIds", productFamilyId);
      if (fromDate && toDate) {
        fromDate = this.util.timeFormatter(moment("00:00:00", "h:mm A").format("h:mm A"), moment(fromDate, "YYYY-MM-DD").format("YYYY-MM-DD")).toISOString();
        toDate = this.util.timeFormatter(moment("23:59:00", "h:mm A").format("h:mm A"), moment(toDate, "YYYY-MM-DD").format("YYYY-MM-DD")).toISOString();
        params = params
          .set("createdFrom", fromDate)
          .set("createdTo", toDate);
      }
  
      if (parameters)
        params = params
          .set("startFrom", parameters.startRow)
          .set("perPage", "25")
          .set("columnName", parameters.sortModel[0].colId)
          .set("sortOrder", parameters.sortModel[0].sort);
  
      return this.http .get(environment.base_url + "/products/qr", { observe: "response",  params: params }) .pipe( map((resp: any) => {
            return resp;
          }),
          catchError((error) => {
            return throwError(error);
          })
        );
    }
    /*

    * Create Product
    * @param body
    * @returns Observable<any>
    */
  public getProductSKUNumbers(body: any) {
    return this.http .post(environment.base_url + '/products/qr/sku', body, { observe: "response" })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }
  /**================================== List Of Asset =========================*/
    public getAssetListByFilterForAddAsset(
      search: any,
      assetTypeId: any,
      statusId: any,
      fromDate: any,
      toDate: any,
      origin: any,
      parameters: any,
    ) {
      let params = new HttpParams();
      if (search) params = params.set("search", search);
      if (assetTypeId) params = params.set("assetTypeIds", assetTypeId);
      if (statusId) params = params.set("statusId", statusId);
      if (origin) params = params.set("origin", origin);
      if (fromDate && toDate) {
        fromDate = this.util.timeFormatter(moment("00:00:00", "h:mm A").format("h:mm A"), moment(fromDate, "YYYY-MM-DD").format("YYYY-MM-DD")).toISOString();
        toDate = this.util.timeFormatter(moment("23:59:00", "h:mm A").format("h:mm A"), moment(toDate, "YYYY-MM-DD").format("YYYY-MM-DD")).toISOString();
        params = params
          .set("createdFrom", fromDate)
          .set("createdTo", toDate);
      }
  
      if (parameters)
        params = params
          .set("startFrom", parameters.startRow)
          .set("perPage", "25")
          .set("columnName", parameters.sortModel[0].colId)
          .set("sortOrder", parameters.sortModel[0].sort);
  
      return this.http .get(environment.base_url + "/assets/lookup", { observe: "response",  params: params }) .pipe( map((resp: any) => {
            return resp;
          }),
          catchError((error) => {
            return throwError(error);
          })
        );
    }
 public addAssetIntoCustomerSiteProject(body: any, module: any) {
    return this.http.put(environment.base_url + '/assets/link/'+ module, body, { observe: "response" })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }
}
